var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSgveteries(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.721 18H54.65v8.484a9.147 9.147 0 01-3.036.516c-5.021 0-9.108-4.038-9.108-9 0-4.963 4.087-9 9.108-9h6.072V0h-6.072c-10.06 0-18.216 8.06-18.216 18s8.156 18 18.216 18c1.036 0 2.049-.09 3.036-.253a18.239 18.239 0 009.108-4.335V18h-3.036zm-41.746-4.5h-7.59c-1.256 0-2.277-1.01-2.277-2.25S10.13 9 11.385 9h15.94V0h-15.94C5.097 0 0 5.036 0 11.25S5.097 22.5 11.385 22.5h7.591c1.255 0 2.276 1.01 2.276 2.25S20.231 27 18.975 27H3.036v9h15.94c6.287 0 11.384-5.036 11.384-11.25S25.263 13.5 18.975 13.5",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.791 18H54.648l15.18 30h12.144l-15.18-30z",
    fill: "#00AEEF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.973 24h12.144L81.973 48H69.829l12.144-24z",
    fill: "#00AEEF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.189 12l6.072 12H94.117l-6.073-12h12.145z",
    fill: "#2BB673"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.118 0l-6.073 12H75.901l6.072-12h12.145z",
    fill: "#FBB040"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSgveteries);
export default __webpack_public_path__ + "static/media/sgveteries.aa7c3dc29133c7eafb8c7bf836ced5f4.svg";
export { ForwardRef as ReactComponent };